module.exports = __webpack_public_path__ + "website/img/saas-1.09e536b3.jpg";